export const getImageUrl = (path) => {
  // Fallback image if no path
  if (!path)
    return "/images/fallback-RB.png";

  // If already complete URL
  if (path.startsWith("http")) return path;

  // Clean path and build complete URL
  const cleanPath = path.replace(/^\/+/, "");
  const baseURL = process.env.REACT_APP_API;

  return `${baseURL}/${cleanPath}`;
};

// Export fallback constant for reuse
export const FALLBACK_IMAGE =
  "/images/fallback-RB.png";
